export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full mb-4">
            联系我们
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            投稿与咨询
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed mb-8">
            如果您发现每日大赛网址更新、有入口变更信息或有任何问题需要反馈，欢迎通过以下方式与我们取得联系。我们会在第一时间处理您的信息。
          </p>

          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-1">邮件联系</h4>
                <p className="text-xs text-foreground-500">service@51daily.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-message-3-line text-xl text-accent-600"></i>
                </div>
                <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-1">在线反馈</h4>
                <p className="text-xs text-foreground-500">站内留言即时响应</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-share-forward-line text-xl text-secondary-600"></i>
                </div>
                <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-1">网址提交</h4>
                <p className="text-xs text-foreground-500">提交每日大赛最新入口</p>
              </div>
            </div>

            <div className="max-w-md mx-auto">
              <form className="flex flex-col gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="您的邮箱地址"
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 transition-colors text-foreground-800"
                />
                <textarea
                  name="message"
                  placeholder="请描述您的问题或反馈…"
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 transition-colors text-foreground-800 resize-none"
                ></textarea>
                <input
                  type="text"
                  name="website_alt"
                  className="honeypot-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="button"
                  className="whitespace-nowrap w-full px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm"
                >
                  发送信息
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}